module.exports = __webpack_public_path__ + "img/invitation_envelope.9f8e6fd2.png";